import script from "./productListTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./productListTable.vue?vue&type=script&lang=ts&setup=true"

import "./productListTable.vue?vue&type=style&index=0&id=345a59e3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345a59e3"]])

export default __exports__